// Fairfield University's bachelor's majors (#2739). Read on 2026-10-01 from
// the official 2026-2027 Academic Catalog's Programs list
// (catalog.fairfield.edu/programs, rendered in a browser): every program the
// list types "Bachelors", grouped by the college or school it names, with
// the degree as the catalog writes it. Economics is listed twice, as a BA in
// Arts and Sciences and a BS in the Dolan School of Business; the Finance and
// Computer Science dual major is listed by both schools. Curriculum and
// Instruction has no degree in the list; its catalog page says it leads to
// the bachelor of arts. Left out: minors, certificates, five-year
// bachelor's/master's programs, graduate programs, the Second Degree BSN
// (for students who already hold a bachelor's degree) and the Bachelor in
// Liberal and Professional Studies (a degree-completion program for adult
// and transfer students), and the Bellarmine associate degrees.
const majors = {
    "slug": "fairfield-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's major in Fairfield's official 2026-2027 Academic Catalog, by college or school. Minors, certificates, five-year bachelor's/master's programs and graduate programs are left out.",
    "groups": [
        {
            "name": "John Charles Meditz College of Arts and Sciences",
            "source": {
                "label": "Fairfield University Academic Catalog 2026-2027, Programs",
                "url": "https://catalog.fairfield.edu/programs/"
            },
            "majors": [
                {
                    "name": "American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Art History and Visual Culture",
                    "degree": "BA"
                },
                {
                    "name": "Behavioral Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry (ACS certified)",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Communication",
                    "degree": "BA"
                },
                {
                    "name": "Digital Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BA"
                },
                {
                    "name": "Film, Television, and Media Arts",
                    "degree": "BA"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "German",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Individually Designed Major",
                    "degree": "BA"
                },
                {
                    "name": "International Studies",
                    "degree": "BA"
                },
                {
                    "name": "Italian",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Politics",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Public Relations",
                    "degree": "BA"
                },
                {
                    "name": "Quantitative Economics",
                    "degree": "BS"
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Sociology and Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Sports Media",
                    "degree": "BA"
                },
                {
                    "name": "Studio Art",
                    "degree": "BA"
                },
                {
                    "name": "Theatre",
                    "degree": "BA"
                },
                {
                    "name": "Women, Gender, and Sexuality Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Dolan School of Business",
            "source": {
                "label": "Fairfield University Academic Catalog 2026-2027, Programs",
                "url": "https://catalog.fairfield.edu/programs/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BS"
                },
                {
                    "name": "Business Analytics",
                    "degree": "BS"
                },
                {
                    "name": "Dual major in Finance and Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "Finance",
                    "degree": "BS"
                },
                {
                    "name": "Integrated Business and Engineering",
                    "degree": "BS"
                },
                {
                    "name": "International Business",
                    "degree": "BS"
                },
                {
                    "name": "Management",
                    "degree": "BS"
                },
                {
                    "name": "Marketing",
                    "degree": "BS"
                },
                {
                    "name": "Sports Business",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Education and Human Development",
            "source": {
                "label": "Fairfield University Academic Catalog 2026-2027, Programs",
                "url": "https://catalog.fairfield.edu/programs/"
            },
            "majors": [
                {
                    "name": "Curriculum and Instruction",
                    "degree": "BA"
                },
                {
                    "name": "Social Work",
                    "degree": "BSW"
                }
            ]
        },
        {
            "name": "School of Engineering and Computing",
            "source": {
                "label": "Fairfield University Academic Catalog 2026-2027, Programs",
                "url": "https://catalog.fairfield.edu/programs/"
            },
            "majors": [
                {
                    "name": "Biomedical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Dual major in Computer Science and Finance",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechatronics Engineering",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Marion Peckham Egan School of Nursing and Health Studies",
            "source": {
                "label": "Fairfield University Academic Catalog 2026-2027, Programs",
                "url": "https://catalog.fairfield.edu/programs/"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "BS"
                },
                {
                    "name": "Public Health",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
